module.exports = __webpack_public_path__ + "static/media/web_1-37.4ab42f99.jpg";